import { render } from "./kprogress.vue?vue&type=template&id=e8490e90&scoped=true"
import script from "./kprogress.vue?vue&type=script&lang=js"
export * from "./kprogress.vue?vue&type=script&lang=js"

import "./kprogress.vue?vue&type=style&index=0&id=e8490e90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e8490e90"

export default script